import React, { Component } from 'react';
import { Button, Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from "react-router";

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { ActionButton } from "components/common";
import { AgencyForm } from 'components/blocks/agency';
import AgencyDetailScreen from './AgencyDetailScreen';
import ProfileListScreen from './ProfileListScreen';


class AgencyScreen extends Component {
    state = {
        id: null,
    };

    componentDidMount() {
        const { actions, match } = this.props;
        actions.agencyDetailLoad({ id: match.params.id });
        this.setState({ id: match.params.id });
    }

    showEditForm = (item = null) => {
        const { actions } = this.props;
        actions.agencyShowEditForm({ show: true, object: item });
    };

    delete = () => {
        const { actions } = this.props;
        const { id } = this.state;
        actions.agencyDelete({ id });
    };

    render() {
        const { agency, history } = this.props;
        const detail = agency.detail || {};

        return (
            <Page>
                <PageHeader
                    history={history}
                    title={detail.name_en}
                    actions={[
                        <Button onClick={() => this.showEditForm(detail)}>
                            <Icon type="edit"/>
                            <span>Редактировать</span>
                        </Button>,
                        <ActionButton
                            actions={[
                                {
                                    key: 'delete',
                                    icon: <Icon type="delete"/>,
                                    title: 'Удалить',
                                    action: this.delete,
                                    confirm: {
                                        title: 'Уверены, что хотите удалить?',
                                        okText: 'Удалить',
                                        cancelText: 'Отмена'
                                    }
                                },
                            ]}
                        />
                    ]}
                    basePath={`/agency/${this.state.id}`}
                    tabs={[
                        { title: 'Детали', key: 'detail' },
                        { title: 'Анкеты', key: 'profiles' },
                    ]}
                />

                <Route exact path="/agency/:id" component={AgencyDetailScreen}/>
                <Route exact path="/agency/:id/profiles" component={ProfileListScreen}/>

                <AgencyForm/>
            </Page>
        );
    }
}


function mapStateToProps(state) {
    return {
        agency: state.agency,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.agency), dispatch),
        dispatch: dispatch
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AgencyScreen);
